import React from 'react';
import styled from 'styled-components';
import { mQ } from 'pages/styles/common';
import AdditionalComments from 'components/AdditionalComments';
import AccountManager from 'components/AccountManager';

const AccountDetailsLayout = styled.div`
  ${mQ.md`
      display: flex;
      background: #fff 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 10px;
  `}
`;

const AdditionalCommentsComponent = styled.div`
  ${mQ.md`
    margin-top: 32px;
    width: 65%;
  `}
`;

const AccountManagerComponent = styled.div`
  ${mQ.md`
     width: 35%;
  `}
`;

const VerticalLine = styled.div`
  border-left: 1px solid #707070;
  opacity: 0.35;
  margin: 32px 0 45px 0;
`;

const AccountDetails = ({ accountManagerDetails }) => {
  return (
    <AccountDetailsLayout>
      <AdditionalCommentsComponent>
        <AdditionalComments />
      </AdditionalCommentsComponent>
      <VerticalLine />
      <AccountManagerComponent>
        <AccountManager accountManagerDetails={accountManagerDetails} />
      </AccountManagerComponent>
    </AccountDetailsLayout>
  );
};

export default AccountDetails;
